// import { GET_SERVICE } from './../constants';
import { handleActions } from "redux-actions"

export const services  = handleActions(
  {
    // [ GET_SERVICE ]: (state, action) => action.payload
  }, []
)